"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnonymousId = void 0;
exports.getCampaign = getCampaign;
exports.trackEvent = exports.sendEnhancedItemClicked = exports.itemClicked = exports.getCid = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _get3 = _interopRequireDefault(require("lodash/get"));

var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");

var _queryString = _interopRequireDefault(require("query-string"));

var _analyticsDefaultProperties = require("./analyticsDefaultProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getAnonymousId = function getAnonymousId() {
  var anonymousUserId = '';

  if (typeof window !== 'undefined') {
    var ajsAnonymousId = (0, _cookieUtils.getCookie)('ajs_anonymous_id');
    anonymousUserId = ajsAnonymousId === undefined ? '' : ajsAnonymousId;
  }

  return anonymousUserId;
};

exports.getAnonymousId = getAnonymousId;

var itemClicked = function itemClicked(activityLocation) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<<attributes.data-track-description.value>>';
  var otherProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    click: {
      name: 'Item Clicked',
      properties: _objectSpread(_objectSpread({
        description: description,
        activityLocation: activityLocation
      }, _analyticsDefaultProperties.defaultProps), otherProps)
    }
  };
};

exports.itemClicked = itemClicked;

var trackEvent = function trackEvent(name, activityLocation) {
  var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '<<attributes.data-track-description.value>>';
  var otherProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    click: {
      name: name,
      properties: _objectSpread(_objectSpread({
        description: description,
        activityLocation: activityLocation
      }, _analyticsDefaultProperties.defaultProps), otherProps)
    }
  };
};

exports.trackEvent = trackEvent;

var sendEnhancedItemClicked = function sendEnhancedItemClicked(activityLocation) {
  var description = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<<attributes.data-track-description.value>>';
  var otherProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return {
    click: {
      name: 'Item Clicked',
      properties: _objectSpread(_objectSpread({
        description: description,
        activityLocation: activityLocation
      }, _analyticsDefaultProperties.defaultReviewImportProps), otherProps)
    }
  };
};

exports.sendEnhancedItemClicked = sendEnhancedItemClicked;

function getCampaign(key) {
  if (process.env.IS_BROWSER) {
    return (0, _get3["default"])(_queryString["default"].parse(window.location.search), key) || (0, _cookieUtils.getCookie)(key);
  }

  return undefined;
}

var getCid = function getCid() {
  return getCampaign('cid');
};

exports.getCid = getCid;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/analytics/analyticsHelpers.js
// module id = 1282
// module chunks = 25